import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Grid, Alert, CircularProgress } from '@mui/material';
import useDataFetch, { usePostDataFetch } from '../../utils/useDataFetch';

const Absences = () => {
    const { data, error, isLoading, refetch } = useDataFetch({ url: '/absences' });
    const { postData: submitAbsence, isLoading: isSubmitting } = usePostDataFetch();

    const [formData, setFormData] = useState({ start_datum: '', end_datum: '', grund: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        await submitAbsence({ url: '/absences', aBody: formData, skipAuth: false });
        setFormData({ start_datum: '', end_datum: '', grund: '' });
        refetch();
    };

    return (
        <Box sx={{ p: { xs: 2, md: 5 }, maxWidth: 800, mx: 'auto' }}>
            <Typography variant="h4" gutterBottom>Abwesenheiten verwalten</Typography>

            <Grid container spacing={4}>
                <Grid size={{ xs: 12, md: 5 }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>Neue Abwesenheit eintragen</Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Termine in diesem Zeitraum werden automatisch für dich abgesagt.
                            </Typography>

                            <form onSubmit={handleSubmit}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <TextField
                                        required
                                        label="Von"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={formData.start_datum}
                                        onChange={e => setFormData({ ...formData, start_datum: e.target.value })}
                                    />
                                    <TextField
                                        required
                                        label="Bis"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={formData.end_datum}
                                        onChange={e => setFormData({ ...formData, end_datum: e.target.value })}
                                    />
                                    <TextField
                                        label="Grund (Optional)"
                                        multiline
                                        rows={2}
                                        value={formData.grund}
                                        onChange={e => setFormData({ ...formData, grund: e.target.value })}
                                    />
                                    <Button variant="contained" type="submit" disabled={isSubmitting}>
                                        Eintragen
                                    </Button>
                                </Box>
                            </form>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid size={{ xs: 12, md: 7 }}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>Deine Abwesenheiten</Typography>
                            {isLoading ? <CircularProgress /> : error ? <Alert severity="error">{error}</Alert> : (
                                <Box>
                                    {data?.absences?.length > 0 ? (
                                        data.absences.map(a => (
                                            <Box key={a.id} sx={{ mb: 2, p: 2, bgcolor: 'background.default', borderRadius: "12px" }}>
                                                <Typography variant="body1" fontWeight="bold">
                                                    {new Date(a.start_datum).toLocaleDateString()} - {new Date(a.end_datum).toLocaleDateString()}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">Grund: {a.grund || '-'}</Typography>
                                            </Box>
                                        ))
                                    ) : (
                                        <Typography variant="body2">Keine Abwesenheiten eingetragen.</Typography>
                                    )}
                                </Box>
                            )}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Absences;
